<template>
  <el-table-column
    prop="completed_at"
    sortable="custom"
    label="Teljesítés dátuma"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.status === 'done'">{{ scope.row.completed_at | date }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'completed_at',
  };
</script>
